import React from 'react';
import PropTypes from 'prop-types';
import { List } from '@pella/sash-framework';
import { CTA } from '../../../../';

const SupportMenu = ({ data }) => {
	return (
		<div className='pal-supportMenu'>
			<List
				bullets='none'
				className='flex flex-wrap'
			>
				{data?.subnav?.[0]?.ctas?.[0] &&
					data.subnav[0].ctas.map((link, index) => (
						<li
							key={index}
							className='max-w-[170px] flex-[0_0_170px] font-semibold'
						>
							<CTA
								data={link}
								className='no-underline hover:underline focus:underline'
							/>
						</li>
					))}
			</List>
		</div>
	);
};

SupportMenu.propTypes = {
	data: PropTypes.object,
};

export default SupportMenu;
